import React from "react";
import "./style.css"

function Header() {
    return(
        <div className="header">
            <h1>
                To-do List
            </h1>
        </div>
    )
}


export default Header;
